import { render, staticRenderFns } from "./Besoins2Roues.vue?vue&type=template&id=5b0b7000&scoped=true&"
import script from "./Besoins2Roues.vue?vue&type=script&lang=js&"
export * from "./Besoins2Roues.vue?vue&type=script&lang=js&"
import style0 from "./Besoins2Roues.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Besoins2Roues.vue?vue&type=style&index=1&id=5b0b7000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b7000",
  null
  
)

export default component.exports